export const PRODUCT_REQUEST="PRODUCT_REQUEST";
export const PRODUCT_FAILURE="PRODUCT_FAILURE";

export const GET_PRODUCT_SUCCESS="GET_PRODUCT_SUCCESS"

